jQuery(document).ready(function ($) {
    const blocks = $('.recommend-products-block .recommend-products-block__right-side');

    blocks.each((key, block) => {
        const swiper_element = $(block).find('.swiper').get(0);
        const prev = $(block).find('.slider-navs__prev').get(0);
        const next = $(block).find('.slider-navs__next').get(0);
        const pagination = $(block).find('.slider-navs__pag').get(0);

        new Swiper(swiper_element, {
            spaceBetween: 10,
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    pagination: {
                        enabled: true
                    }
                },
                651: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                    pagination: {
                        enabled: true
                    }
                },
                750: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    pagination: {
                        enabled: true
                    }
                },
                993: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    pagination: {
                        enabled: false
                    }
                }
            }
        });
    });
});
